import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import '../member.scss';
import { Style } from '@/components/style';

const { alertColor } = new Style().getUiConfig();

function RemoveMemberSuccessModal({ show, handleClose, confirmClick }) {
  return (
    <Modal
      className="d-flex justify-content-center"
      dialogClassName="modal-privacy-info"
      show={show}
      onHide={handleClose}
      centered
      scrollable
      backdrop="static"
      backdropClassName="member-backdrop"
    >
      <Modal.Header>
        <div
          className="fw-bolder d-flex justify-content-start"
          style={{
            fontSize: '20px',
            color: alertColor,
          }}
        >
          <FormattedMessage id="member.modal.title.remove.account" />
        </div>
      </Modal.Header>
      <Modal.Body>
        <div
          className="d-flex align-items-center justify-content-center"
          style={{ fontSize: '14px' }}
        >
          <FormattedMessage id="member.modal.title.remove.account.success" />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div
          className="d-flex justify-content-between fw-bolder"
          style={{ width: '100%' }}
        >
          <div />
          <div
            className="remove-member-confirm-button"
            role="presentation"
            onClick={confirmClick}
          >
            <FormattedMessage id="common.confirm" />
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

RemoveMemberSuccessModal.defaultProps = {};

RemoveMemberSuccessModal.propTypes = {
  show: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  confirmClick: PropTypes.func.isRequired,
};

export default RemoveMemberSuccessModal;
